import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';

import { UserActions } from '../store/user.actions';
import { UserState } from '../store/user.state';
import { DebugHelper } from '@shared/helpers/debug.helper';

export const userLoaderGuard: CanActivateFn = () => {
  const store = inject(Store);
  return store.select(UserState.isLoaded)
              .pipe(
                  map((isLoaded) => {
                    if (!isLoaded) {
                      store.dispatch(new UserActions.GetMe())
                           .subscribe({
                             error: (error) => {
                               DebugHelper.log(
                                   'UserLoaderGuard: Error loading user',
                                   error,
                               );
                             },
                           });
                    }
                    return true;
                  }),
              );
};
